import React from "react";
import layoutActions from "@pillvery/redux/layout/actions";
import {useDispatch} from "react-redux";

export default function TopbarToggleButton() {
    const dispatch              = useDispatch();

    function handleToggle() {
        dispatch(layoutActions.toggleSidebar())
    }

    return (
        <button className="navbar-toggler navbar-toggler align-self-center"
                type="button"
                data-toggle="minimize"
                onClick={ handleToggle }
        >
            <span className="mdi mdi-menu"></span>
        </button>
    );
}